import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function TermsOfService() {
  return (
    <div className="min-h-screen pt-[132px] pb-20 px-4 md:px-8 bg-[#050505] text-white">
      <div className="max-w-3xl mx-auto">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-zinc-400 hover:text-teal-400 text-sm mb-10 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to home
        </Link>
        <h1 className="font-heading text-4xl md:text-5xl font-black uppercase tracking-tight mb-2">Terms of Service</h1>
        <p className="text-zinc-500 text-sm mb-10">Last updated: March 2026</p>

        <div className="space-y-8 text-zinc-300 text-sm leading-relaxed">
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Agreement</h2>
            <p>
              By using this website and buying from us, you agree to these terms. <strong className="text-white">SprintFit</strong>{' '}
              operates the brand, store, and checkout (e.g. shop.sprintfit.in). <strong className="text-white">ThermaCube</strong> is
              a SprintFit product line today; other products may join the catalog later. Separate terms shown at checkout may
              also apply to that transaction.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Products &amp; pricing</h2>
            <p>
              We strive to describe products and prices accurately. We reserve the right to correct errors, update pricing,
              or limit quantities. Images are for illustration; minor variations in appearance may occur.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Orders &amp; shipping</h2>
            <p>
              When you place an order, you agree to provide accurate shipping and contact information. Delivery timelines
              depend on location and carrier. Risk of loss passes in accordance with our shipping partner&apos;s terms unless
              stated otherwise at checkout.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Returns, warranty &amp; defects</h2>
            <p className="mb-3">
              For <strong className="text-white">ThermaCube</strong> and other SprintFit products, we aim to be clear: eligible orders
              include a <strong className="text-white">30-day return</strong> window from delivery (subject to product condition,
              original packaging where required, and exclusions noted at checkout). Manufacturing defects are covered by a{' '}
              <strong className="text-white">1-year warranty</strong> from purchase, handled through our support team.
            </p>
            <p>
              Final eligibility, restocking or shipping fees for returns, and warranty claim steps may also be shown on the product
              page, FAQ, or at checkout. Contact{' '}
              <a href="mailto:support@sprintfit.in" className="text-teal-400 hover:underline">
                support@sprintfit.in
              </a>{' '}
              with your order details for returns or warranty help.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Use of the device</h2>
            <p>
              ThermaCube is a wellness product, not a substitute for medical advice. Follow the user manual. Do not use
              contrary to warnings provided with the product or on this site. Consult a healthcare professional for medical
              conditions.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Limitation of liability</h2>
            <p>
              To the fullest extent permitted by law, SprintFit and its affiliates are not liable for indirect
              or consequential damages arising from use of the site or product. Our total liability for any claim relating to
              a product purchase is limited to the amount you paid for that product.
            </p>
          </section>
          <section>
            <h2 className="font-heading text-lg font-bold text-white uppercase tracking-wide mb-3">Contact</h2>
            <p>
              <a href="mailto:support@sprintfit.in" className="text-teal-400 hover:underline">
                support@sprintfit.in
              </a>
            </p>
          </section>
          <p className="text-zinc-500 text-xs pt-4 border-t border-white/10">
            These terms are a general summary. If any part conflicts with mandatory local law, that law applies to the
            extent required.
          </p>
        </div>
      </div>
    </div>
  );
}
